import React from 'react';
import { 
  Lightbulb, 
  Ticket, 
  Dice1, 
  BookOpen, 
  TestTube,
  Code, 
  Gamepad2
} from 'lucide-react';

/**
 * Компонент боковой панели с описанием сценариев использования генератора
 */
const UseCasesSidebar = () => {
  const useCases = [
    {
      icon: Ticket,
      title: 'Лотереи и розыгрыши',
      description: 'Генерация номеров для лотерей, розыгрышей и конкурсов.',
      color: 'text-green-500'
    },
    {
      icon: Dice1,
      title: 'Игры и настольные игры',
      description: 'Случайные числа для замены кубиков или создания игровых ситуаций.',
      color: 'text-blue-500'
    },
    {
      icon: BookOpen,
      title: 'Образование',
      description: 'Создание случайных задач, тестов или выбор случайных учеников.',
      color: 'text-purple-500'
    },
    {
      icon: TestTube,
      title: 'Научные исследования',
      description: 'Статистическое моделирование и организация экспериментов.',
      color: 'text-amber-500'
    },
    {
      icon: Code,
      title: 'Тестирование ПО',
      description: 'Генерация тестовых данных для проверки программного обеспечения.',
      color: 'text-indigo-500'
    },
    {
      icon: Gamepad2,
      title: 'Игровые сервера',
      description: 'Генерация случайных игровых событий и создание процедурного контента.',
      color: 'text-rose-500'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Lightbulb className="w-5 h-5 mr-2 text-yellow-500" />
        Применение генератора
      </h3>

      <div className="space-y-3">
        {useCases.map((useCase, index) => (
          <div 
            key={index} 
            className="p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <div className="flex items-start space-x-3">
              <useCase.icon className={`w-5 h-5 ${useCase.color} mt-0.5 flex-shrink-0`} />
              <div>
                <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                  {useCase.title}
                </h4>
                <p className="text-xs text-gray-600 dark:text-gray-400">
                  {useCase.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Lightbulb className="w-5 h-5 text-indigo-500 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-indigo-700 dark:text-indigo-300 mb-2">
              Случайные числа в России
            </h4>
            <p className="text-xs text-indigo-600 dark:text-indigo-400 mb-3">
              В России генераторы случайных чисел используются в лотереях «Гослото», «Русское лото», а также в системах государственного распределения квот и для подбора присяжных заседателей в судебной системе.
            </p>
            <a 
              href="/tools/generators/lottery-numbers"
              className="text-xs font-medium text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 dark:hover:text-indigo-300 transition-colors"
            >
              Узнать больше о генераторах для лотерей →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UseCasesSidebar;